<template>
    <highcharts
        class="chart h-100 min-height-300"
        :constructor-type="'chart'"
        :options="chartOptions"
    ></highcharts>
</template>
<script>
    export default {
        props: {
            connectionsData: {
                type: Array,
                default: []
            }
        },
        data() {
            return {
                chartOptions: {
                    chart: {
                        type: 'bar'
                    },
                    credits: {
                        enabled: false
                    },
                    title: {
                        text: ''
                    },
                    xAxis: {
                        categories: this.getCategoriesX()
                    },
                    yAxis: {
                        min: 0,
                        title: {
                            text: 'Processing status'
                        }
                    },
                    legend: {
                        reversed: true
                    },
                    plotOptions: {
                        series: {
                            stacking: 'normal'
                        }
                    },
                    series: [{
                        name: 'Already Processing',
                        color: 'rgb(113,134,157)',
                        data: this.getSeriesAlreadyProcessing()
                    }, {
                        name: 'Waiting',
                        color: 'rgb(245,202,153)',
                        data: this.getSeriesWaiting()
                    }, {
                        name: 'Failed',
                        color: 'rgb(237,76,120)',
                        data: this.getSeriesFailed()
                    }, {
                        name: 'Success',
                        color: 'rgb(0,201,167)',
                        data: this.getSeriesSuccess()
                    }]
                }
            }
        },
        methods: {
            getCategoriesX() {
                let a = [];
                this.connectionsData.forEach(el => {
                    a.push(el.connection_type);
                });
                return a;
            },
            getSeriesWaiting() {
                let waiting = [];
                this.connectionsData.forEach(el => {
                    waiting.push(el.waiting);
                });
                return waiting;
            },
            getSeriesFailed() {
                let failed = [];
                this.connectionsData.forEach(el => {
                    failed.push(el.failed);
                });
                return failed;
            },
            getSeriesSuccess() {
                let failed = [];
                this.connectionsData.forEach(el => {
                    failed.push(el.completed);
                });
                return failed;
            },
            getSeriesAlreadyProcessing() {
                let failed = [];
                this.connectionsData.forEach(el => {
                    failed.push(el.already_processing);
                });
                return failed;
            }
        }
    };
</script>
